var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAvalaraLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 97.3 21.1",
    style: {
      enableBackground: "new 0 0 97.3 21.1"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1498CE;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#EE6925;}\n\t.st2{fill:#FC6600;}\n\t.st3{fill:#EE6925;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.9,15.9c0,0-1-1.3-1.6-1.9l-0.9,2c1.2,1.8,2,3.4,2.5,4.2c0.9-1.5,3-5.8,7.4-9.9l-0.5-1.1 C13.9,11.2,11.5,13.9,9.9,15.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.8,16.3c0,1.2,0.7,1.8,1.8,2v2.9c-3.2,0-5-1.6-5-4.6V0h3.2V16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.9,6.2c-4,0-7.2,3.3-7.2,7.4c0,4.1,3.1,7.4,6.9,7.4c1.9,0,3.5-0.7,4.4-1.8l0.2,0.1v1.5h3.2V6.5h-3.2v1 l-0.1,0.1C67.1,6.7,65.8,6.2,63.9,6.2 M64.3,18.4c-2.4,0-4.4-2.1-4.4-4.8c0-2.7,2-4.8,4.4-4.8c1.6,0,2.9,0.5,3.9,1.2v6.1 C67.4,17.8,65.9,18.4,64.3,18.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.1,20.8h3.2v-10c1-1,2.4-1.7,4-1.7H82V6.2h-0.4c-1.7,0-3.2,0.8-4.2,2l-0.2-0.1V6.5h-3.2V20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.5,6.2c-4,0-7.2,3.3-7.2,7.4c0,4.1,3.1,7.4,6.9,7.4c1.9,0,3.5-0.7,4.4-1.8l0.2,0.1v1.5H48V6.5h-3.2v1 l-0.1,0.1C43.7,6.7,42.4,6.2,40.5,6.2 M40.9,18.4c-2.4,0-4.4-2.1-4.4-4.8c0-2.7,2-4.8,4.4-4.8c1.6,0,2.9,0.5,3.9,1.2v6.1 C44,17.8,42.5,18.4,40.9,18.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.8,6.2c-4,0-7.2,3.3-7.2,7.4c0,4.1,3.1,7.4,6.9,7.4c1.9,0,3.5-0.7,4.4-1.8l0.2,0.1v1.5h3.2V6.5h-3.2v1 L94,7.5C93,6.7,91.7,6.2,89.8,6.2 M90.2,18.4c-2.4,0-4.4-2.1-4.4-4.8c0-2.7,2-4.8,4.4-4.8c1.6,0,2.9,0.5,3.9,1.2v6.1 C93.3,17.8,91.8,18.4,90.2,18.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M16.3,20.7h3.5l-3.1-7.4c-0.9,1-1.7,1.9-2.3,2.8L16.3,20.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "30.2,6.5 25.7,16.9 25.6,16.9 25.6,16.9 25.6,16.9 25.6,16.9 25.6,16.9 25.5,16.9 25.5,16.9 21,6.5  17.6,6.5 24,20.7 24,20.7 24,20.7 27.2,20.7 27.2,20.7 27.2,20.7 33.6,6.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11.4,0.8L11.4,0.8H8.4h0L0,20.7h3.5l6-14.2l0.3-0.8H10l0.3,0.8l1.8,4.2c0.8-0.8,1.7-1.6,2.6-2.3L11.4,0.8z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAvalaraLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Avalara_logo.e50dae2e7c5f7c7bcf24734f4965f612.svg";